import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`

  body {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    
    /* font-family: "Roboto", sans-serif; */
    line-height: 1.5;    
    /* text-align: var(--bs-body-text-align); */
    
    background-color: ${({ theme }) => theme.branding.backgroundColor};
  }
  
  /* large */
  @media (min-width: 1200px){

  }

  /* medium */
  @media (max-width: 1199.98px) {
  }

  @media (max-width: 575.98px) {

  }

  *{
    box-sizing: inherit;
  }
`;

export default GlobalStyle;
